{
  "import.inkind.20230223": "Changes in column-name for date.",
  "warning.30days": "Obs! Changes in the Excel-template within the past 30 days!",
  "warning.tips": "It may be wise to download the template again to avoid any conflicts."
}
